export default __webpack_public_path__ + "static/media/light_from_scy.0afec712.png";